import {
  listarNotificacoesRespostaSchema,
  notificacaoPainelSchema,
  type StatusNotificacao,
} from '@varga/shared';
import { api } from '../lib/http';

/** `GET /v1/notificacoes?status=` — fila FIFO (ordenada por `criadoEm` asc). */
export async function listarNotificacoes(status?: StatusNotificacao) {
  const qs = status ? `?status=${status}` : '';
  const r = await api(listarNotificacoesRespostaSchema, `/v1/notificacoes${qs}`);
  return r.itens;
}

/**
 * `POST /v1/notificacoes/:id/enviada` — marca como enviada. 409 `conflito` quando
 * outro operador chegou primeiro (`detalhes: { enviadaPor, enviadaEm }`).
 */
export function marcarEnviada(id: string) {
  return api(notificacaoPainelSchema, `/v1/notificacoes/${id}/enviada`, { method: 'POST' });
}
